import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import SponsorsTableWrapper from './table/SponsorsTableWrapper';

export function SponsorsCard() {
  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Sponsors</h3>
        </Col>
      </Row>
      <Row>
        <SponsorsTableWrapper />
      </Row>
    </Container>
  );
}
